<template>
    <div class="footer">
        <div class="footer-center">
            <div class="footer-main">
                <div class="footer-main__logo" @click="goHome"></div>
                <div class="main-wrapper">
                    <div class="main-wrapper__top">
                        <div 
                            class="top-item"
                            v-for="item in list"
                            :key="item.path"
                            @click="jump(item)"
                        >
                            <el-popover
                                popper-class="popover2"
                                placement="bottom-start"
                                width="50"
                                trigger="hover">
                                <div class="top-item__list">
                                    <div 
                                        class="top-item__list--item"
                                        v-for="item2 in item.children"
                                        :key="item2.id"
                                        @click.stop="jumpSecond(item, item2)"
                                    >{{item2.name}}</div>
                                </div>
                                <div slot="reference">{{item.name}}</div>
                            </el-popover>
                              
                        </div>
                        
                    </div>
                    
                    <!-- <div class="center-line"></div> -->
                    <div class="right-text" >
                        <div @click="goTop">归</div>
                        <div 
                            class="right-text__search" 
                            :class="[isShowSearch ? 'show' : '']"
                        >
                            <input 
                                type="text"
                                placeholder="您想寻找内容的文字"
                                autofocus
                                v-model="searchFooter"
                                @keydown.enter="jumpSearch"
                            >
                            <div
                                @mouseover="showSearch"
                                @click="jumpSearch"
                            >寻</div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="footer-bottom">
                <div class="bottom-item">Copyright  ©  {{year}} chinese.nenu.edu.cn All Rights Reserved </div>
                <div class="bottom-item">版权所有：东北师范大学文学院 </div>
                <div class="bottom-item">技术支持：北京欢喜自在科技有限公司 </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            searchFooter: '',
            isShowSearch: false,
            year: new Date().getFullYear(),
            list: [{
                name: "学院概况",
                path: 'college',
                children: [{
                    name: '学院简介',
                    id: 0
                }, {
                    name: '历史沿革',
                    id: 1
                }, {
                    name: '知名学者',
                    id: 2
                }, {
                    name: '领导团队',
                    id: 3
                }, {
                    name: '组织机构',
                    id: 4
                }]
            }, {
                name: "人才培养",
                path: 'talents',
                children: [{
                    name: '本科生教育',
                    id: 0
                }, {
                    name: '研究生教育',
                    id: 1
                }, {
                    name: '博士后流动站',
                    id: 2
                }, {
                    name: '教学成果',
                    id: 3
                }]
            }, {
                name: "师资力量",
                path: 'staff',
                children: [{
                    name: '专任教师',
                    id: 0
                }, {
                    name: '行政教辅',
                    id: 1
                }, {
                    name: '外聘教师',
                    id: 2
                }]
            }, {
                name: "学术研究",
                path: 'science',
                children: [{
                    name: '学科方向',
                    id: 0
                }, {
                    name: '学术活动',
                    id: 1
                }, {
                    name: '学术成果',
                    id: 2
                }, {
                    name: '学术刊物',
                    id: 3
                }]
            }, {
                name: "党建园地",
                path: 'party',
                children: [{
                    name: '党群组织',
                    id: 0
                }, {
                    name: '党建制度',
                    id: 1
                }, {
                    name: '党建活动',
                    id: 2
                }, {
                    name: '学习资料',
                    id: 3
                }]
            }, {
                name: "学生工作",
                path: 'student',
                children: [{
                    name: '学工制度',
                    id: 0
                }, {
                    name: '学生活动',
                    id: 1
                }]
            }]
        }
    },
    watch: {
        '$route'() {
            this.isShowSearch = false
            this.searchFooter = ''
        }
    },
    methods: {
        goHome() {
            this.$router.push({
                name: 'home'
            })
        },
        jump(item) {
            this.$router.push({
                name: item.path
            })
            this.refreshRoute()
        },
        jumpSecond(item, item2) {
            this.$router.push({
                name: item.path,
                params: {
                    id: item2.id
                }
            })
        },
        goTop() {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        showSearch() {
            this.isShowSearch = true
        },
        jumpSearch() {
            this.isShowSearch = false
            
            if (this.$route.name != 'search') {
                this.$router.push({
                    name: 'search'
                })
            }
            
            this.$store.commit('setSearch', this.searchFooter)
            this.searchFooter = ''
            this.goTop()
        }
    }
}
</script>

<style lang="less">
    .footer-center{
        width: 70%;
        margin: 0 auto;
    }
    .footer{
        min-height: 400px;
        min-width: 600px;
        background: rgb(30, 0,155);
        &-main{
            height: 360px;
            position: relative;
            display: flex;
            &__logo{
                width: 180px;
                height: 170px;
                background-image: url('https://p.gsxcdn.com/585524187_9erq6gv9.jpg');
                // background-image: url('/asstes/images/bottom-logo.jpg');
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center top;
                margin-right: 30px;
                cursor: pointer;
            }
            &__line1{
                height: 200px;
                border-right: 1px solid #8e7fcd;
                margin-right: 30px;
            }
        }
    }
    .popover2{
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
        .popper__arrow{
            display: none !important;
        }
    }
    .main-wrapper{
        flex: 1;
        margin-top: 70px;
        margin-left: 10px;
        &__top{
            display: flex;
            margin-left: 20px;
            .top-item{
                color: white;
                font-size: 1.6rem;
                width: 22px;
                word-wrap: break-word;
                margin-right: 6%;
                line-height: 24px;
                position: relative;
                padding-bottom: 60px;
                cursor: pointer;
                .top-item__list{
                    position: absolute;
                    width: 300px;
                    left: 0;
                    top: 120px;
                    display: none;
                    font-family: DemiLightff;
                    
                }
                .top-item:hover{
                    .top-item__list{
                        display: block;
                    }
                }
            }
        }
        
    }
    .top-item__list--item{
        color: #0082FF;
        font-size: 1.4rem;
        margin-bottom: 6px;
        cursor: pointer;
    }
    .right-text{
        position: absolute;
        right: 0;
        top: 0;
        width: 20px;
        color: white;
        font-size: 1.6rem;
        line-height: 68px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        &:after{
            content: '';
            position: absolute;
            right: -15px;
            bottom: 18px;
            height: 30px;
            border-right: 1px solid white;
        }
        &__search{
            display: flex;
            align-items: center;
            position: relative;
            input{
                padding-left: 12px;
                color: #fff;
                height: 30px;
                font-size: 1.4rem;
                width: 0;
                border: none;
                outline: none;
                background: #1e009b;
                transition: all 0.2s linear;
            }
            &.show{
                padding-left: 5px;
                input{
                    width: 200px;

                }
            }
            &::before{
                content: '';
                position: absolute;
                left: 0;
                bottom: 18px;
                height: 30px;
                border-left: 1px solid white;
            }
        }
    }
    .center-line{
        position: absolute;
        top: 90px;
        right: 22%;
        height: 30px;
        border-right: 1px solid white;
    }
    .footer-bottom{
        padding-left: 20px;
        height: 50px;
        display: flex;
        align-items: center;
        border-top: 1px solid #1528ba;
    }
    .bottom-item{
        color: #0082FF;
        font-size: 1.2rem;
        margin-right: 40px;
    }
</style>